define('v3/Pages/AbilityGraph/Components/Legend/Legend.Component',[
	'v3/FromV2/cultureService',
	'text!v3/Pages/AbilityGraph/Components/Legend/Legend.Component.html'], function (cultureService, template) {
	function legend () {
		var self = this;
		self.showOneFAndOneS = cultureService.isCurrentCountryNl();

		self.Heading = Strings.Legend;
		self.FarAboveAverage = Strings.Level + ' 5';
		self.AboveAverage = Strings.Level + ' 4';
		self.Average = Strings.Level + ' 3';
		self.BelowAverage = Strings.Level + ' 2';
		self.FarBelowAverage = Strings.Level + ' 1';

		if (this.showOneFAndOneS) {
			self.OneF = Strings.OneF;
			self.OneS = Strings.OneS;
		}
	};

	return { viewModel: legend, template: template };
});
